<template slot-scope="scope">
  <!-- 服务范围选择弹窗 -->
      <dialogModel
        title="选择服务范围"
        :visible.sync="dialogServiceScope"
        @handleClose="handleCloseServiceScope"
        @handleOk="ServiceScope"
      >
        <div class="main-body">
          <div class="MajorItems"></div>
          <div class="MinorItems"></div>
        </div>
      </dialogModel>
</template>

<script>
export default {
  props: {
    dialogServiceScope: {},
  },
  components: {},
  data() {
    return {};
  },

  computed: {},
  created() {},
  methods: {
    // 关闭弹窗
    handleCloseServiceScope() {
      this.$emit("handleCloseServiceScope");
    },
    ServiceScope() {
      this.$emit("ServiceScope");
    },
  },
};
</script>

<style scoped lang="less">
// 调整对话框

.dialog-title {
  width: 100%;
  height: 70px;
  border-bottom: 1px dashed #409eff ;

  .off {
    width: 100%;
    height: 25px;
    display: flex;
    justify-content: flex-end;
    div {
      width: 18px;
      height: 18px;
      background-image: url("../../../../../../assets/imgs/guanbi.svg");
      background-size: 100% 100%;
      margin-top: 15px;
      margin-right: 15px;
    }
  }
  .Instructions {
    font-size: 12px;
    color: #999999;
  }
  p {
    width: 100%;
    height: 28px;
    line-height: 28px;
    font-family: PingFangSC-Medium;
    font-size: 16px;
    color: #409eff ;
    font-weight: 400;
    text-indent: 20px;
  }
}

.main-body {
  .MajorItems {
    width: 100%;
    min-height: 100px;
    padding: 20px;
    display: flex;
    flex-wrap: wrap;
  }
  .MinorItems {
    width: 100%;
    min-height: 100px;
    padding: 20px;
    display: flex;
    flex-wrap: wrap;
  }
}
</style>
